var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { msg } from '@lit/localize';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { BaseShadowless } from '../indicator/BaseShadowless';
import { MapTilerDefaultLayer } from './controls/layerModel/baseLayers/mapTilerDefaultLayer';
/**
 * Represents the layer base component
 */
let DinapsisMapBaseLayer = class DinapsisMapBaseLayer extends BaseShadowless {
    constructor() {
        super(...arguments);
        /**
         * A property that is used to load the base layers of map.
         */
        this.baseLayers = [];
        /**
         * A private variable for layer selected
         */
        this.idLayerSelected = '';
        /**
         * A private variable that helps in the creation of the default base layers of map tiler
         */
        this.defaultMapTilerHandler = new MapTilerDefaultLayer();
    }
    /**
     * A function that change css for base layer selected
     * @param id Id base layer selected
     * @returns Class css for the base layer
     */
    getClassLayer(id) {
        if (id === this.idLayerSelected) {
            return 'dinapsis-map-base-layer-selected';
        }
        return 'dinapsis-map-base-layer';
    }
    /**
     * A function that change css for name layer selected
     * @param id Id base layer selected
     * @returns Class css for the name layer
     */
    getClassNameLayer(id) {
        if (id === this.idLayerSelected) {
            return 'dinapsis-map-base-layer-name-selected';
        }
        return 'dinapsis-map-base-layer-name';
    }
    /**
     * A function that return the name of the layer base
     * @param layer Base layer to show
     * @returns Name of the layer base
     */
    getNameLayer(layer) {
        let name = '';
        switch (layer.type) {
            case 'DefaultBaseMapLayer':
                name = layer.id;
                break;
            default:
                name = layer.name;
                break;
        }
        return name;
    }
    /**
     * A function that emit an evento to change the selected base layer
     */
    selectLayer(id) {
        if (id !== this.idLayerSelected) {
            this.idLayerSelected = id;
            const baseLayer = this.baseLayers.find((layer) => layer.id === id);
            this.dispatchEvent(new CustomEvent('changeBaseLayer', { detail: { baseLayer } }));
        }
    }
    /**
     * Gets the html for painting thumbnail of base layer manager
     * @param layer Layer
     * @returns lit html
     */
    getThumbnail(layer) {
        if (layer.thumbnail && layer.thumbnail !== '') {
            return html ` <img
            class="dinapsis-map-base-img"
            src="${layer.thumbnail}">`;
        }
        return html `<span class="${this.getThumbnailClass(layer)}"></span>`;
    }
    /**
     * A funtion that return a the classes needed to paint default thumbnail
     * @param layer Base layer
     * @returns Thumbail
     */
    getThumbnailClass(layer) {
        let defaultClass = 'base-image';
        switch (layer.type) {
            case 'DefaultBaseMapLayer': {
                const defaultMapThumbnail = this.defaultMapTilerHandler.getThumbnail(layer.id);
                defaultClass = defaultMapThumbnail ? `${defaultClass} ${defaultMapThumbnail}` : defaultClass;
                break;
            }
            default:
                defaultClass = `${defaultClass} default-base-map`;
                break;
        }
        return defaultClass;
    }
    /**
     * A function that return the base layer rows
     * @returns Html that represents the layer base rows
     */
    createBaseLayerStructure() {
        var _a;
        this.idLayerSelected = ((_a = this.baseLayers.find((x) => x.isActive)) === null || _a === void 0 ? void 0 : _a.id) || '';
        return html `
      ${map(this.baseLayers, (layer) => html `
        <div class="dinapsis-map-base-layer-col">
          <div 
            id="map-base-img-${layer.id}"
            class="${this.getClassLayer(layer.id)}"
            @click="${() => this.selectLayer(layer.id)}"
          >
            ${this.getThumbnail(layer)}
          </div>
          <div class="dinapsis-map-base-div-layer">
            <span class="${this.getClassNameLayer(layer.id)}">${this.getNameLayer(layer)}</span>
          </div>
        </div>
      `)}
    `;
    }
    /**
     * A function that render the layer base component
     * @returns Html that represents the layer base component
     */
    render() {
        return html `
      <div class="dinapsis-map-base-container">
        <div class="dinapsis-map-base-type">
          <span>${msg('mapType')}</span></br>
        </div>
        <div class="dinapsis-map-base-layer-row">
          ${this.createBaseLayerStructure()}
        </div>
      </div>
    `;
    }
};
__decorate([
    property({
        type: (Array),
    })
], DinapsisMapBaseLayer.prototype, "baseLayers", void 0);
__decorate([
    state()
], DinapsisMapBaseLayer.prototype, "idLayerSelected", void 0);
DinapsisMapBaseLayer = __decorate([
    customElement('dinapsis-map-base-layer')
], DinapsisMapBaseLayer);
export { DinapsisMapBaseLayer };
//# sourceMappingURL=dinapsis-map-base-layer.js.map